import {Module, VuexModule, getModule, Action} from 'vuex-module-decorators'
import store from '@/store'
import user_module from "@/modules/user"

import new_axios from "axios";
import {axios} from "@/plagins";
import {Planposition} from "./types";


// import lead_module from '@/modules/leadCardSingle/index'

@Module({
  namespaced: true,
  name: 'PlanStore',
  store,
  dynamic: true
})

class LeadAttachmentsStore extends VuexModule {
  plans: Array<any> = []

  @Action({rawError: true})
  public async searchPlans(str: string | (string | null)[]) {
    try {

      const headers = {'content-type': 'multipart/form-data;'}

      const params: any = {
        // token: user_module.Token,
        // login: user_module.Login,
        rowsToReturn: 7,
        system: 'LEXE',
        SearchStr: str,
        action: 'GETINCREMENTALSEARCHONPLANS'
      }

      let formData = new FormData();

      for (const paramIdx in params){

        const param: any = params[paramIdx];
        formData.append(paramIdx, param)
      }

      const newInstance = new_axios.create();

      const response: any = await newInstance({
        baseURL: process.env.VUE_APP_LEXE_API_URL,
        url: '',
        headers,
        method: 'post',
        data: formData
      })

      console.log(">>>>>>>>>>>> getFileData ---> response: ", response)

      if (response.data.PS.Result !== 'Success') {
        return
      } else {
        return Promise.resolve(response.data.PS.Plan)
      }

    } catch (err) {
      return Promise.reject(err)
    }
  }

  @Action({rawError: true})
  public async savePlan(plan: {planposition: Planposition, EIN: string, PN: string}) {

    try {
        const headers = {
          'content-type': 'multipart/form-data;',
        }

        const params: any = {
          plan: JSON.stringify(plan),
          action: 'SAVEUSERPLAN',
          login: user_module.Login,
          token: user_module.token
        }

        if (user_module.fingerprint){
          params.fingerprint = user_module.fingerprint;
        }
  
        let formData = new FormData();
  
        for (const paramIdx in params){
  
          const param: any = params[paramIdx];
          formData.append(paramIdx, param)
        }

        const response: any = await axios({
            baseURL: process.env.VUE_APP_FILES_API_URL,
            url: '',
            headers,
            method: 'post',
            data: formData
        })
    

      console.log(">>>>>>>>>>>> savePlan ---> response: ", response)

      if (response.data.FCT.Result !== 'Success') {
        return
      } else {
        return Promise.resolve(response.data.FCT)
      }

    } catch (err) {
      return Promise.reject(err)
    }
  }

}

export default getModule(LeadAttachmentsStore)